import { FormDialogConfig, Icon } from '@aibees/shared/components';
import { yup } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';

export const config: FormDialogConfig = {
  title: (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <Icon
        size={20}
        name="person-delete-outline"
        sxx={{ color: (p) => p.palette.primary[500] }}
      />
      <Typography variant="body2">Delete User</Typography>
    </Stack>
  ),
  headerSx: {
    backgroundColor: (p) => p.palette.primary[50],
    borderBottom: (p) => `1px solid ${p.palette.primary[100]}`,
    paddingY: 1.5,
  },
  closeButton: {
    children: 'Cancel',
    variant: 'text',
    sx: { border: 0 },
  },
  actionsSx: {
    borderTop: (p) => `1px solid ${p.palette.primary[100]}`,
    marginTop: 0,
  },
};

export const scheme = yup.object().shape({
  confirmed: yup
    .bool()
    .oneOf([true], 'Please Confirm deleting member before submit'),
});
